import { Controller } from "@hotwired/stimulus"

// Fades the full-size thumbnail in over its blurred placeholder once the
// browser has finished loading it (see Academy::ThumbnailsHelper).
export default class extends Controller {
  static targets = ["image"]

  // Handles images already loaded before the controller connects (browser
  // cache, Turbo restore) — their `load` event has already fired.
  imageTargetConnected(image) {
    if (image.complete && image.naturalWidth > 0) this.reveal()
  }

  reveal() {
    this.element.classList.add("is-loaded")
  }
}
